import { Dictionary } from 'vue-router/types/router';
import { PermissionsGroup, FilterableCardName } from '@/store/models.def';


const transactionsNames: Dictionary<string> = {
	DOCDATE: 'date',
	CR: 'cr',
	DR: 'dr',
	ACCTYPE: 'accType',
	SPECIALACCTYPE: 'specialAccType',
	ACCTYPENAME: 'accTypeName',
	SPECIALACCTYPENAME: 'specialAccTypeName',
	AMOUNT: 'amount',
	SPECIALACCTYPECODE: 'specialAccTypeCode',
	PARENTACCCODE: 'parentAccCode',
	PARENTACCDESC: 'parentAccDesc',
	PROJECT: 'project',
};

const cashFlowNames: Dictionary<string> = {
	POSTDATE: 'postDate',
	CODE: 'code',
	JOURNAL: 'journal',
	ACCOUNT: 'account',
	FROMTO: 'fromTo',
	PURPOSE: 'purpose',
	CASHIN: 'cashIn',
	CASHOUT: 'cashOut',
};

const salesNames: Dictionary<string> = {
	DOCDATE: 'date',
	DOCNO: 'docNo',
	DOCTYPE: 'docType',
	AMOUNT: 'amount',
	AGENT: 'agent',
	STOCKGROUP: 'stockGroup',
	ITEMCODE: 'itemCode',
	CODE: 'code',
	COSTINGMETHOD: 'costingMethod',
	QUANTITY: 'quantity',
	DISCOUNT: 'discount',
	DISCOUNTTAXINC: 'discountTaxInc',
	TAX: 'tax',
	COST: 'cost',
	AREA: 'area',
	COMPANYCATEGORY: 'companyCategory',
	PROFIT: 'profit',
	DOCPROJECT: 'docProject',
	DTLPROJECT: 'dtlProject',
};
const quotationsNames: Dictionary<string> = {
	DOCDATE: 'date',
	DOCNO: 'docNo',
	AMOUNT: 'amount',
	AGENT: 'agent',
	STOCKGROUP: 'stockGroup',
	ITEMCODE: 'itemCode',
	CODE: 'code',
	// COSTINGMETHOD: 'costingMethod',
	QUANTITY: 'quantity',
	DISCOUNT: 'discount',
	TAX: 'tax',
	DISCOUNTTAXINC: 'discountTaxInc',
	OUTSTANDINGAMOUNT: 'outstandingAmount',
	OSQTY: 'outstandingQuantity',
	TRANSFERREDAMT: 'transferredAmt',
	SEQ: 'sequence',
};
const salesOrderNames: Dictionary<string> = {
	DOCDATE: 'date',
	DOCNO: 'docNo',
	AMOUNT: 'amount',
	AGENT: 'agent',
	STOCKGROUP: 'stockGroup',
	ITEMCODE: 'itemCode',
	CODE: 'code',
	// COSTINGMETHOD: 'costingMethod',
	QUANTITY: 'quantity',
	DISCOUNT: 'discount',
	TAX: 'tax',
	DISCOUNTTAXINC: 'discountTaxInc',
	OUTSTANDINGAMOUNT: 'outstandingAmount',
	OSQTY: 'outstandingQuantity',
	TRANSFERREDAMT: 'transferredAmt',
	SEQ: 'sequence',
	DELIVERYDATE: 'delivery_date',
	LASTINVOICEDATE: 'last_invoice_date',
};
const purchasesNames: Dictionary<string> = {
	DOCDATE: 'date',
	DOCNO: 'docNo',
	DOCTYPE: 'docType',
	AMOUNT: 'amount',
	AGENT: 'agent',
	STOCKGROUP: 'stockGroup',
	ITEMCODE: 'itemCode',
	CODE: 'code',
	// COSTINGMETHOD: 'costingMethod',
	QUANTITY: 'quantity',
	DISCOUNT: 'discount',
	DISCOUNTTAXINC: 'discountTaxInc',
	TAX: 'tax',
	COST: 'cost',
};
const stockBalancesNames: Dictionary<string> = {
	SYEAR: 'year',
	SMONTH: 'month',
	AMOUNT: 'amount',
	PROJECT: 'project',
	DOCDATE: 'date',
};
const customersNames: Dictionary<string> = {
	CODE: 'code',
	COMPANYNAME: 'companyName',
	COMPANYCATEGORY: 'companyCategory',
	COMPANYCATEGORYDESC: 'companyCategoryDesc',
	LAT: 'lat',
	LNG: 'lng',
	AGENT: 'agent',
	AGENTDESC: 'agentDesc',
	FIRSTDEAL: 'firstDeal',
	FIRSTDEALAGENT: 'firstDealAgent',
	LASTDEAL: 'lastDeal',
	AREA: 'area',
	AREADESC: 'areaDesc',
	CREDITLIMIT: 'creditLimit',
	CREDITTERM: 'creditTerm',
	CL_LASTREVIEW: 'lastReviewDate',
	STATUS: 'status',
};
const customerIvDnsNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCKEY: 'docKey',
	DOCNO: 'docNo',
	CODE: 'code',
	DOCDATE: 'date',
	TERMS: 'terms',
	DUEDATE: 'dueDate',
	AGENT: 'agent',
	// CURRENCYRATE: 'currencyRate',
	// DOCAMT: 'foreignAmount',
	LOCALDOCAMT: 'amount',
	// DOCOSAMT: 'foreignOsAmount',
	LOCALDOCOSAMT: 'osAmount',
	DOCLASTKODOCDATE: 'lastKoDocDate',
};
const customerKosNames: Dictionary<string> = {
	TODOCKEY: 'toDocKey',
	TODOCTYPE: 'toDocType',
	TODOCNO: 'toDocNo',
	TODOCDATE: 'date',
	TODOCDUEDATE: 'dueDate',
	TODOCLASTKODOCDATE: 'lastKoDocDate',
	// TODOCCURRENCYRATE: 'currencyRate',
	// TODOCOSAMT: 'foreignOsAmount',
	TOLOCALDOCOSAMT: 'osAmount',

	FROMDOCKEY: 'fromDocKey',
	FROMDOCTYPE: 'fromDocType',
	FROMDOCNO: 'fromDocNo',
	FROMDOCCURRENCYRATE: 'koCurrencyRate',
	FROMDOCDATE: 'koDate',

	DOCKEY: 'docKey',
	// KOAMT: 'foreignAmount',
	KOLOCALAMT: 'amount',
	KOGAINLOSS: 'gainLoss',
	AGENT: 'agent',
	CODE: 'code',
};
const customerSalesTransNames: Dictionary<string> = {
	QTY: 'quantity',
	ITEMQTY: 'itemQuantity',
	LOCALAMOUNT: 'amount',
	// AMOUNT: 'foreignAmount',
	LOCALTAXAMOUNT: 'taxAmount',
	// TAXAMOUNT: 'foreignTaxAmount',

	DOCDATE: 'date',
	AGENT: 'agent',
	CODE: 'code',
	COMPANYCATEGORY: 'companyCategory',
};
const customerTradesNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCDATE: 'date',
	DUEDATE: 'dueDate',
	CODE: 'code',
	COMPANYCATEGORY: 'companyCategory',
	AGENT: 'agent',
	AREA: 'area',
	DOCPROJECT: 'docProject',
	DTLPROJECT: 'dtlProject',
	DOCREFS: 'docRefs',
	LOCALAMOUNT: 'amount',
	// AMOUNT: 'foreignAmount',
	LOCALTAXAMT: 'taxAmount',
	// TAXAMOUNT: 'foreignTaxAmount',
	UNAPPLIEDAMT: 'unappliedAmount',
	LOCALUNAPPLIEDAMT: 'lUnappliedAmount',
	LOCALOSAMOUNT: 'lOsAmount',
};
const customerNetSalesNames: Dictionary<string> = {
	DOCDATE: 'date',
	LOCALAMOUNT: 'amount',
	// AMOUNT: 'foreignAmount',
};
const supplierTradesNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCDATE: 'date',
	DUEDATE: 'dueDate',
	CODE: 'code',
	COMPANYCATEGORY: 'companyCategory',
	AGENT: 'agent',
	LOCALAMOUNT: 'amount',
	// AMOUNT: 'foreignAmount',
	LOCALTAXAMOUNT: 'taxAmount',
	// TAXAMOUNT: 'foreignTaxAmount',
	UNAPPLIEDAMT: 'unappliedAmount',
  LOCALOSAMOUNT: 'lOsAmount',
  LOCALUNAPPLIEDAMT: 'lUnappliedAmount',
};
const supplierNetCogsNames: Dictionary<string> = {
	DOCDATE: 'date',
	LOCALAMOUNT: 'amount',
	// AMOUNT: 'foreignAmount',
};

const suppliersNames: Dictionary<string> = {
	CODE: 'code',
	COMPANYNAME: 'companyName',
	COMPANYCATEGORY: 'companyCategory',
	COMPANYCATEGORYDESC: 'companyCategoryDesc',
	LAT: 'lat',
	LNG: 'lng',
	AGENT: 'agent',
	AGENTDESC: 'agentDesc',
};
const supplierPiSdsNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCKEY: 'docKey',
	DOCNO: 'docNo',
	CODE: 'code',
	DOCDATE: 'date',
	TERMS: 'terms',
	DUEDATE: 'dueDate',
	AGENT: 'agent',
	// CURRENCYRATE: 'currencyRate',
	// DOCAMT: 'foreignAmount',
	LOCALDOCAMT: 'amount',
	// DOCOSAMT: 'foreignOsAmount',
	LOCALDOCOSAMT: 'osAmount',
	DOCLASTKODOCDATE: 'lastKoDocDate',
};
const supplierKosNames: Dictionary<string> = {
	TODOCKEY: 'toDocKey',
	TODOCTYPE: 'toDocType',
	TODOCNO: 'toDocNo',
	TODOCDATE: 'date',
	TODOCDUEDATE: 'dueDate',
	TODOCLASTKODOCDATE: 'lastKoDocDate',
	// TODOCCURRENCYRATE: 'currencyRate',
	// TODOCOSAMT: 'foreignOsAmount',
	TOLOCALDOCOSAMT: 'osAmount',

	FROMDOCKEY: 'fromDocKey',
	FROMDOCTYPE: 'fromDocType',
	FROMDOCNO: 'fromDocNo',
	FROMDOCCURRENCYRATE: 'koCurrencyRate',
	FROMDOCDATE: 'koDate',

	DOCKEY: 'docKey',
	// KOAMT: 'foreignAmount',
	KOLOCALAMT: 'amount',
	KOGAINLOSS: 'gainLoss',
	AGENT: 'agent',
	CODE: 'code',
};
const supplierPurchaseTransNames: Dictionary<string> = {
	QTY: 'quantity',
	ITEMQTY: 'itemQuantity',
	LOCALAMOUNT: 'amount',
	AMOUNT: 'foreignAmount',
	LOCALTAXAMOUNT: 'taxAmount',
	// TAXAMOUNT: 'foreignTaxAmount',

	DOCDATE: 'date',
	AGENT: 'agent',
	CODE: 'code',

	COMPANYCATEGORY: 'companyCategory',
};
const stockTransNames: Dictionary<string> = {

	POSTDATE: 'date',

	DOCTYPE: 'docType',
	DOCNO: 'docNo',
	QTY: 'quantity',
	QTYIN: 'quantityIn',
	QTYOUT: 'quantityOut',
	AMOUNTIN: 'amountIn',
	AMOUNTOUT: 'amountOut',
	COST: 'cost',
	PRICE: 'price',

	ITEMCODE: 'itemCode',
	STOCKGROUP: 'stockGroup',
	LOCATION: 'location',
};
const stockPurchaseOrderNames: Dictionary<string> = {
	DOCNO: 'docNo',
	ITEMCODE: 'itemCode',
	DELIVERYDATE: 'deliveryDate',
	OSQTY: 'quantity',
	REMARK1: 'remark1',
};
const purchaseRequestOrderNames: Dictionary<string> = {
	DOCDATE: 'date',
	DOCNO: 'docNo',
	AMOUNT: 'amount',
	AGENT: 'agent',
	STOCKGROUP: 'stockGroup',
	ITEMCODE: 'itemCode',
	CODE: 'code',
	QUANTITY: 'quantity',
	DISCOUNT: 'discount',
	TAX: 'tax',
	TRANSFERREDAMT: 'transferredAmt',
	OSQTY: 'osQuantity',
};
const stockUtdBalanceNames: Dictionary<string> = {
	ITEMCODE: 'itemCode',
	DESCRIPTION: 'itemDesc',
	STOCKGROUP: 'stockGroup',
	STOCKGROUPDESC: 'stockGroupDesc',
	GSM: 'gsm',
	SIZE: 'size',
	QTY: 'quantity',
	POQTY: 'poQuantity',
	BRAND: 'brand',
	REMARK1: 'remark1',
	REMARK2: 'remark2',
};
const projectCashFlowNames: Dictionary<string> = {
	MONTH: 'month',
	YEAR: 'year',
	PROJECT: 'projectCode',
	OTHERSTOCK: 'otherStock',
	CUSTOMERDEBIT: 'customerDebit',
	CUSTOMERINVOICE: 'customerInvoice',
	CUSTOMERPAYMENT: 'customerPayment',
	CUSTOMERCONTRA: 'customerContra',
	CUSTOMERCREDIT: 'customerCredit',
	CUSTOMERREFUND: 'customerRefund',
	STOCKISSUE: 'stockIssue',
	STOCKRETURN: 'stockReturn',
	EXPENSES: 'expenses',
	LABOUR: 'labour',
	SUBCON: 'subCon',
};
const projectStockGroupNames: Dictionary<string> = {
	MONTH: 'month',
	YEAR: 'year',
	PROJECT: 'projectCode',
	STOCKGROUP: 'stockGroup',
	COST: 'cost',
};
const projectCostingNames: Dictionary<string> = {
	COSTTYPE: 'costType',
	MONTH: 'month',
	YEAR: 'year',
	PROJECT: 'projectCode',
	COST: 'cost',
};

const agentDbsNames: Dictionary<string> = {
	CODE: 'agent',
	DESCRIPTION: 'agentDesc',
};
const stockDbsNames: Dictionary<string> = {
	CODE: 'itemCode',
	DESCRIPTION: 'itemDesc',
	STOCKGROUP: 'stockGroup',
	STOCKGROUPDESC: 'stockGroupDesc',
	REORDERLEVEL: 'minInvLevel',
	COSTINGMETHOD: 'costingMethod',
	UOM: 'itemUOM',
	LEADTIME: 'leadTime',
	ISACTIVE: 'isActive',
	UDF_DISCON: 'isDiscontinued',
	REORDERQTY: 'reorderQty',
};

const stockAgingNames: Dictionary<string> = {
	STOCKGROUP: 'stockGroup',
	ITEMCODE: 'itemCode',
	DESCRIPTION: 'itemDesc',
	LOCATION: 'location',
	BATCH: 'batch',
	COST: 'cost',
	PRICE: 'price',
	QTYIN: 'quantityIn',
	QTYOUT: 'quantityOut',
	MONTH: 'month',
	YEAR: 'year',
};

const stockAvailabilityNames: Dictionary<string> = {
	POSTDATE: 'postDate',
	LOCATION: 'location',
	ISACTIVE: 'isActive',
	ITEMCODE: 'itemCode',
	DESCRIPTION: 'description',
	STOCKGROUP: 'stockGroup',
	QTY: 'quantity',
	BALANCE: 'balance',
	UOM: 'uom',
	REORDERLEVEL: 'reorderLevel',
};

const stockReorderAdviseNames: Dictionary<string> = {
	POSTDATE: 'postDate',
	LOCATION: 'location',
	ISACTIVE: 'isActive',
	CODE: 'itemCode',
	DESCRIPTION: 'description',
	STOCKGROUP: 'stockGroup',
	QTY: 'quantity',
	BALQTY: 'balance',
	UOM: 'uom',
	REORDERLEVEL: 'reorderLevel',
	REORDERQTY: 'reorderQty',
	OSSOBASEUOMQTY: 'soAmount',
	OSPOBASEUOMQTY: 'poAmount',
	AVGUNITCOST: 'avgCost',
};

const stockBatchExpiryNames: Dictionary<string> = {
	LOCATION: 'location',
	ITEMCODE: 'itemCode',
	BATCH: 'batchNo',
	EXPDATE: 'expiryDate',
	BALQTY: 'balanceQuantity',
	AVGUNITCOST: 'avgCost',
};

const stockSales: Dictionary<string> = {
	DOCTYPE: 'docType',
	POSTDATE: 'date',
	ISACTIVE: 'isActive',
	ITEMCODE: 'itemCode',
	STOCKGROUP: 'stockGroup',
	QTY: 'quantity',
	PRICE: 'price',
};

const stockPurchase: Dictionary<string> = {
	DOCTYPE: 'docType',
	POSTDATE: 'date',
	ISACTIVE: 'isActive',
	ITEMCODE: 'itemCode',
	STOCKGROUP: 'stockGroup',
	QTY: 'quantity',
	COST: 'cost',
};

const stockMovement: Dictionary<string> = {
	POSTDATE: 'postDate',
	STOCKGROUP: 'stockGroup',
	ISACTIVE: 'isActive',
	ITEMCODE: 'itemCode',
	DESCRIPTION: 'description',
	COSTIN: 'costIn',
	PRICEOUT: 'priceOut',
	QTYIN: 'quantityIn',
	QTYOUT: 'quantityOut',
	BALANCEQTY: 'balanceQuantity',
};

const accDbsNames: Dictionary<string> = {
	CODE: 'code',
	PARENT: 'parent',
	GENERATION: 'generation',
	ACCNAME: 'accountName',
	ACCTYPE: 'accountType',
	SPECIALACCTYPE: 'specialAccountType',
};
const projectDbsNames: Dictionary<string> = {
	CODE: 'code',
	DESCRIPTION: 'projectDesc',
	PROJECTVALUE: 'projectValue',
	PROJECTCOST: 'projectCost',
	STATUS: 'status',
	STARTDATE: 'startDate',
	ENDDATE: 'endDate',
	ISACTIVE: 'isActive',
};
const locationDbsNames: Dictionary<string> = {
	CODE: 'code',
	DESCRIPTION: 'description',
};
const areaDbsNames: Dictionary<string> = {
	CODE: 'code',
	DESCRIPTION: 'description',
};
const companyCategoryDbsNames: Dictionary<string> = {
	CODE: 'code',
	DESCRIPTION: 'description',
};
const systemNames: Dictionary<string> = {
	KEY: 'key',
	VAL: 'val',
};

const dashboardSalesNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCDATE: 'date',
	AGENT: 'agent',
	CODE: 'code',
	COMPANYNAME: 'companyName',
	// SL fields
	CASES: 'cases',
	AMOUNT: 'amount',
	TAX: 'tax',
	AMOUNTWITHTAX: 'amountWithTax',
	COST: 'cost',
	PROFIT: 'profit',
	// AR fields
	ARCASES: 'arCases',
	ARAMOUNT: 'arAmount',
	ARTAX: 'arTax',
	ARAMOUNTWITHTAX: 'arAmountWithTax',
};

const dashboardQuotationNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCDATE: 'date',
	AGENT: 'agent',
	AGENTDESC: 'agentDesc',
	CODE: 'code',
	COMPANYNAME: 'companyName',
	AMOUNT: 'amount',
	TAX: 'tax',
	AMOUNTWITHTAX: 'amountWithTax',
	TRANSFERREDAMT: 'transferredAmount',
	TRANSFERREDTAX: 'transferredTax',
	TRANSFERREDAMTWITHTAX: 'transferredAmountWithTax',
	OUTSTANDINGAMOUNT: 'outstandingAmount',
	OUTSTANDINGTAX: 'outstandingTax',
	OUTSTANDINGAMTWITHTAX: 'outstandingAmountWithTax',
};

const dashboardCashFlowNames: Dictionary<string> = {
	DOCDATE: 'date',
	CASHINFLOW: 'cashInFlow',
	CASHOUTFLOW: 'cashOutFlow',
	CASHFLOW: 'cashFlow',
};

const dashboardCashBalanceNames: Dictionary<string> = {
	DOCDATE: 'date',
	SPECIALACCTYPE: 'specialAccountType',
	NETAMT: 'netAmount',
};

const dashboardApArDueNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCNO: 'docNo',
	CODE: 'code',
	COMPANYNAME: 'companyName',
	DOCDATE: 'date',
	DUEDATE: 'dueDate',
	AGENT: 'agent',
	LOCALDOCOSAMT: 'amount',
};

const dashboardDataNames: Dictionary<string> = {
	SALES0: 'sales0',
	SALES1: 'sales1',
	SALES2: 'sales2',
	SALES3: 'sales3',
	SALES4: 'sales4',
	SALES5: 'sales5',
	SALES6: 'sales6',
	SALES7: 'sales7',
	TDYNUMIV: 'todayNumIv',
	TDYPROFIT: 'todayProfit',
	YTDPROFIT: 'ytdProfit',
	TDYNUMQT: 'todayNumQuotation',
	TDYQUOTATION: 'todayQuotadion',
	YTDQUOTATION: 'ytdQuotation',
	CUSTOMERPAYMENT: 'customerPayment',
	SUPPLIERPAYMENT: 'supplierPayment',
	TDYCASHFLOW: 'todayCashFlow',
	YTDCASHFLOW: 'ytdCashFlow',
	CASHONHAND: 'cashOnHand',
	CASHINBANK: 'cashInBAnk',
};

const dashboardStockGroupSalesNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCDATE: 'date',
	STOCKGROUP: 'stockGroup',
	QTY: 'quantity',
	LOCALAMOUNT: 'amount',
	LOCALTAXAMT: 'taxAmount',
};
const dashboardCustomerSupplierDuesNames: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCNO: 'docNo',
	CODE: 'code',
	DOCDATE: 'date',
	DUEDATE: 'dueDate',
	AGENT: 'agent',
	LOCALDOCOSAMT: 'amount',
};

const dashboardArCustomerNames: Dictionary<string> = {
	ACCOUNTID: 'accountId',
	COMPANYNAME: 'companyName',
	DBREMARK: 'dbRemark',
	FDBPATH: 'fdbPath',
	ALLACCESSEMAIL: 'allAccessEmail',
	TOKEN: 'token',
	UDF_PLAN: 'udfPlan',
	STARTDATE: 'startDate',
	ENDDATE: 'endDate',
	DEALERID: 'dealerId',
	DEALERDESC: 'dealerDesc',
	VERSION: 'version',
};

const diyDailyProjectSales: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCDATE: 'docDate',
	STORELOCATION: 'storeLocation',
	LOCALDOCAMT: 'localDocAmount',
};

const diyStockPackingBudget: Dictionary<string> = {
	DOCDATE: 'docDate',
	STOCKGROUP: 'stockGroup',
	COSTINGMETHOD: 'costingMethod',
	ITEMCODE: 'itemCode',
	LOCATION: 'location',
	COST: 'cost',
	BUDGETAMT: 'budgetAmount',
};

const diySalesSummary: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCDATE: 'date',
	MONTH: 'month',
	YEAR: 'year',
	CODE: 'code',
	TYPE: 'type',
	COMPANYNAME: 'companyName',
	COMPANYCATEGORY: 'companyCategory',
	AMOUNT: 'amount',
	MISCAMOUNT: 'miscAmount',
	TAX: 'tax',
	AMOUNTWITHTAX: 'amountWithTax',
	COST: 'cost',
	PROFIT: 'profit',
	MARGIN: 'margin',
	REFCOST: 'refCost',
	REFCOSTPROFIT: 'refCostProfit',
	REFCOSTMARGIN: 'refCostMargin',
};

const diyMaintainStockItem: Dictionary<string> = {
	STOCKGROUP: 'stockGroup',
	ISACTIVE: 'isActive',
	CODE: 'itemCode',
	DESCRIPTION: 'itemDesc',
	REMARK1: 'remark1',
	BALSQTY: 'balQty',
	UOM: 'uom',
	REFPRICE: 'refPrice',
	REFCOST: 'refCost',
	BARCODE: 'barCode',
};

const diySupportRenewal: Dictionary<string> = {
	RN: 'rowNumber',
	DOCTYPE: 'docType',
	DOCDATE: 'docDate',
	CODE: 'code',
	COMPANYNAME: 'companyName',
	ITEMCODE: 'itemCode',
	ITEMDESCRIPTION: 'itemDesc',
    REMARK1: 'remark1',
	QTY: 'qty',
	UOM: 'uom',
	AMOUNT: 'amount',
	FEE: 'fee',
	MASTERCONAME: 'masterCompanyName',
	EMAIL: 'email',
	EXPDATE: 'expDate',
	DESC: 'desc',
};

const diyBudgetVsActual: Dictionary<string> = {
	BYEAR: 'year',
	BMONTH: 'month',
	PROJECT: 'project',
	ACCOUNT: 'acc',
	DESCRIPTION: 'desc',
	ACCGROUP: 'accGroup',
	BUDGET: 'budget',
	YTDSPEND: 'ytdSpend',
	VARIANCE: 'variance',
};

const diyUserAccess: Dictionary<string> = {
	PROJECT: 'project',
	COMPANYNAME: 'userEmail',
};

const diyCurrentFinancialPeriod: Dictionary<string> = {
	STARTDATE: 'startDate',
	ENDDATE: 'endDate',
};

const diyGLTrans: Dictionary<string> = {
	POSTDATE: 'date',
	DOCNO: 'docNo',
	DESCRIPTION: 'desc',
	GLACCCODE: 'code',
	GLACCNAME: 'name',
	DTLDESC: 'dtlDesc',
	PROJECT: 'project',
	AMOUNT: 'amount',
};

const diyActualPerformance: Dictionary<string> = {
	PROJECT: 'project',
	DYEAR: 'year',
	DMONTH: 'month',
	ACCTYPE: 'accType',
	LOCALDR: 'localDr',
	LOCALCR: 'localCr',
};

const diyGlobalBudget: Dictionary<string> = {
	PROJECT: 'project',
	BYEAR: 'year',
	BMONTH: 'month',
	ACCOUNT: 'account',
	DR: 'dr',
	CR: 'cr',
};

/**
 * IV / CS / DN / CN in one table (KIM CHOK SDN BHD custom dashboard).
 * AMOUNT is SUM(LOCALAMOUNT) — home currency, before tax; TAX is SUM(LOCALTAXAMT).
 * CN rows are stored POSITIVE, so the consumer subtracts them.
 *
 * Grouped by LOCATION (detail location = branch; 1 per branch, unlike DOCPROJECT
 * which splits a branch into per-counter project codes), STOCKGROUP (system stock
 * group) and UDF_GROUP (a DIY field that merges several stock groups into one
 * higher-level group — self-describing, no separate code/description). (Query V1-3.)
 */
const diySalesIvCsDnCn: Dictionary<string> = {
	DOCTYPE: 'docType',
	DOCDATE: 'date',
	CODE: 'code',
	LOCATION: 'location',
	STOCKGROUP: 'stockGroup',
	UDF_GROUP: 'udfGroup',
	AMOUNT: 'amount',
	TAX: 'tax',
};

const closingStockBalance: Dictionary<string> = {
	TRANSNO: 'transNo',
	ITEMCODE: 'itemCode',
	POSTDATE: 'postDate',
	LOCATION: 'location',
	BATCH: 'batch',
	STOCKGROUP: 'stockGroup',
	COSTINGMETHOD: 'costingMethod',
	UTDQTY: 'utdQty',
	UTDCOST: 'utdCost',
    SEQ: 'seq',
};

export const headerTransform: { [T in FilterableCardName]?: Dictionary<string> } = {
	transactions: transactionsNames,
	cashflow: cashFlowNames,
	stockBalances: stockBalancesNames,
	sales: salesNames,
	creditNotes: salesNames,
	quotations: quotationsNames,
	salesOrder: salesOrderNames,
	purchases: purchasesNames,
	purchaseReturn: purchasesNames,
	stockTrans: stockTransNames,
	stockUtdBalance: stockUtdBalanceNames,
	stockPurchaseOrder: stockPurchaseOrderNames,
	stockAging: stockAgingNames,
	stockAvailability: stockAvailabilityNames,
	stockSales,
	stockPurchase,
	stockMovement,
	stockReorderAdvise: stockReorderAdviseNames,
	stockBatchExpiry: stockBatchExpiryNames,
	purchaseOrder: purchaseRequestOrderNames,
	purchaseRequest: purchaseRequestOrderNames,
	projectCashFlow: projectCashFlowNames,
	projectStockGroup: projectStockGroupNames,
	projectCosting: projectCostingNames,
	customers: customersNames,
	customerIvDns: customerIvDnsNames,
	customerKos: customerKosNames,
	customerNetSales: customerNetSalesNames,
	customerSalesTrans: customerSalesTransNames,
	customerTrades: customerTradesNames,
	suppliers: suppliersNames,
	supplierPiSds: supplierPiSdsNames,
	supplierKos: supplierKosNames,
	supplierNetCogs: supplierNetCogsNames,
	supplierPurchaseTrans: supplierPurchaseTransNames,
	supplierTrades: supplierTradesNames,
	dashboardData: dashboardDataNames,
	dashboardStockGroupSales: dashboardStockGroupSalesNames,
	dashboardCustomersDue: dashboardCustomerSupplierDuesNames,
	dashboardSuppliersDue: dashboardCustomerSupplierDuesNames,
	dashboardSales: dashboardSalesNames,
	dashboardQuotation: dashboardQuotationNames,
	dashboardCashFlow: dashboardCashFlowNames,
	dashboardCashBalance: dashboardCashBalanceNames,
	dashboardApArDue: dashboardApArDueNames,
	dashboardArCustomer: dashboardArCustomerNames,
	globalAgents: agentDbsNames,
	globalStocks: stockDbsNames,
	globalAcc: accDbsNames,
	globalCustomers: customersNames,
	globalSuppliers: suppliersNames,
	globalProjects: projectDbsNames,
	globalLocations: locationDbsNames,
	globalArea: areaDbsNames,
	globalCompanyCategory: companyCategoryDbsNames,
	diyDailyProjectSales,
	diyStockPackingBudget,
	diySalesSummary,
	diyMaintainStockItem,
	diySupportRenewal,
    diyBudgetVsActual,
	diyUserAccess,
	diyCurrentFinancialPeriod,
	diyGLTrans,
	diyGlobalCustomers: customersNames,
	diyGlobalStocks: stockDbsNames,
	diyStockTrans: stockTransNames,
	diyActualPerformance,
	diyGlobalBudget,
	diySalesIvCsDnCn,
	closingStockBalance,
	system: systemNames,
};

export const forceStringFields = ['docNo', 'docType', 'agent', 'agentDesc', 'code', 'companyName', 'customerDesc', 'supplierDesc',
	'itemCode', 'itemDesc', 'stockGroup', 'stockGroupDesc', 'companyCategory', 'companyCategoryDesc', 'firstDealAgent'];
